// ──────────────────────────────────────────────
// GeoDrops Frontend — Type Definitions
// ──────────────────────────────────────────────

export type PinCategory =
  | "food"
  | "drinks"
  | "event"
  | "deal"
  | "workspace"
  | "meetup"
  | "alert"
  | "other";

export interface Pin {
  id: string;
  telegram_user_id: number;
  author_name: string;
  lat: number;
  lng: number;
  category: PinCategory;
  message: string;
  expires_at: string;
  created_at: string;
  distance_m?: number;
}

export interface CreatePinInput {
  lat: number;
  lng: number;
  category: PinCategory;
  message: string;
  expires_in_minutes: number;
}

export interface CategoryMeta {
  key: PinCategory;
  label: string;
  emoji: string;
  color: string;
}

export const CATEGORIES: CategoryMeta[] = [
  { key: "food", label: "Food", emoji: "🍕", color: "#f97316" },
  { key: "drinks", label: "Drinks", emoji: "🍻", color: "#8b5cf6" },
  { key: "event", label: "Event", emoji: "🎉", color: "#ec4899" },
  { key: "deal", label: "Deal", emoji: "💰", color: "#22c55e" },
  { key: "workspace", label: "Workspace", emoji: "💻", color: "#3b82f6" },
  { key: "meetup", label: "Meetup", emoji: "👋", color: "#eab308" },
  { key: "alert", label: "Alert", emoji: "⚠️", color: "#ef4444" },
  { key: "other", label: "Other", emoji: "📌", color: "#6b7280" },
];

export function getCategoryMeta(key: PinCategory): CategoryMeta {
  return CATEGORIES.find((c) => c.key === key) || CATEGORIES[CATEGORIES.length - 1];
}

export function formatDistance(meters?: number): string {
  if (meters == null) return "";
  if (meters < 1000) return `${Math.round(meters)}m`;
  return `${(meters / 1000).toFixed(1)}km`;
}

export function formatTimeLeft(expiresAt: string): string {
  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) return "expired";
  const mins = Math.floor(ms / 60000);
  if (mins < 60) return `${mins}m left`;
  const hours = Math.floor(mins / 60);
  const remainMins = mins % 60;
  return remainMins > 0 ? `${hours}h ${remainMins}m left` : `${hours}h left`;
}
